import {AccordionSummary, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';
import {StyledAccordion, StyledAccordionDetails} from './styles';
import {AccordionDataProps} from './types';

const AccordionData = ({title, subtitle, children, expandIcon, ...rest}: AccordionDataProps) => {
	const theme = useTheme();

	const getTitle = () => {
		if (typeof title === 'string') {
			return (
				<Typography variant="subtitle2" color="text.secondary">
					{title}
				</Typography>
			);
		}

		return title;
	};

	return (
		<StyledAccordion {...rest}>
			<AccordionSummary
				expandIcon={
					expandIcon || (
						<Icon
							name="expand-more-filled"
							color={theme.palette.primary.main}
							size={32}
						/>
					)
				}
				aria-controls="panel1-content"
				id="panel1-header">
				<Stack gap={0.5}>
					{getTitle()}
					<Typography variant="subtitle1">{subtitle}</Typography>
				</Stack>
			</AccordionSummary>
			<StyledAccordionDetails>
				<Stack spacing={2}>{children}</Stack>
			</StyledAccordionDetails>
		</StyledAccordion>
	);
};

export {AccordionData};
